import axios from '@/utils/request'
const urlPrefix = 'map'

// 获取需求列表
export function getDemandList (params) {
  return axios({
    url: urlPrefix + '/demand/page',
    method: 'GET',
    params: params
  })
}

// 新增需求
export function addDemand (params) {
  return axios({
    url: urlPrefix + '/demand',
    method: 'POST',
    data: params
  })
}

// 编辑需求
export function editDemand (params) {
  return axios({
    url: urlPrefix + '/demand',
    method: 'PUT',
    data: params
  })
}

// 删除需求
export function delDemand (params) {
  return axios({
    url: urlPrefix + '/demand',
    method: 'DELETE',
    data: params
  })
}

// 获取需求类型下拉框
export function getDemandSelect (params) {
  return axios({
    url: urlPrefix + '/demand/type',
    method: 'GET',
    params: params
  })
}

// 获取需求详情
export function getDemandDetails (params) {
  return axios({
    url: urlPrefix + '/demand',
    method: 'GET',
    params: params
  })
}

// 获取数据成果列表
export function getDataList (params) {
  return axios({
    url: urlPrefix + '/demandAchievement/page',
    method: 'GET',
    params: params
  })
}

// 获取数据成果详情
export function getEventDetails (params) {
  return axios({
    url: urlPrefix + '/demandAchievement',
    method: 'GET',
    params: params
  })
}

// 获取事件类型下拉框
export function getEventSelect (params) {
  return axios({
    url: urlPrefix + '/demandAchievement/type',
    method: 'GET',
    params: params
  })
}

// 需求成果导入数据管理
export function demandAchievementImport (params) {
  return axios({
    url: urlPrefix + '/demandAchievement/import',
    method: 'POST',
    params: params
  })
}

// 获取未导入数据管理的数据成果数量
export function getAchievementImportCount (params) {
  return axios({
    url: urlPrefix + '/demandAchievement/unImportCount',
    method: 'GET',
    params: params
  })
}
